import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavigationLink } from "navigation-react";

const TopActionMenus = ({
  // actionmenuesClass = "",
  addLabel = "",
  AddTitle = "",
  faUsersIcon,
  stateKey = "",
  navigationData = "",
  backLable = "",
  backIcon,
  distance,
  ctscanAddUserStateKey = "",
  ctscanAddUsernavigationData = "",
  ctscanAddUseraddLabel = "",
  ctscanAddUserfaUsersIcon,
  ctscanRegisteraddLabel = "",
  ctscanRegisterfaUsersIcon,
  ctscanRegisternavigationData = "",
  ctscanRegisterstateKey = "",
  onClick,
  onClickIcon,
  onClickSize = "",
  buttonLabel = "",
  backNavigationLink,
  itemizedSalesonClick,
  itemizedSalesIcon,
  itemizedSalesSize = "",
  itemizedSalesLabel = "",
  onClickCategoryRegister,
  onClickCatRegIcon,
  onClickCatRegSize = "",
  buttonCatRegLabel = "",
  onClickSupplierRegister,
  onClickSupRegIcon,
  onClickSupRegSize = "",
  buttonSupRegLabel = "",
}) => {
  return (
    <div className="patient-register-header">
      <div className="patient-register-header-title">
        {backNavigationLink && (
          <NavigationLink distance={distance} stateKey={backNavigationLink}>
            <FontAwesomeIcon icon={backIcon} />
            {backLable}
          </NavigationLink>
        )}
        <h2>{AddTitle}</h2>
      </div>
      <div className="header-button">
        <ul>
          {ctscanAddUserStateKey && (
            <li>
              <NavigationLink
                stateKey={ctscanAddUserStateKey}
                navigationData={ctscanAddUsernavigationData}
              >
                <FontAwesomeIcon icon={ctscanAddUserfaUsersIcon} />
                {ctscanAddUseraddLabel}
              </NavigationLink>
            </li>
          )}
          {stateKey && (
            <li>
              <NavigationLink
                stateKey={stateKey}
                navigationData={navigationData}
              >
                <FontAwesomeIcon icon={faUsersIcon} /> {addLabel}
              </NavigationLink>
            </li>
          )}
          {ctscanRegisterstateKey && (
            <li>
              <NavigationLink
                stateKey={ctscanRegisterstateKey}
                navigationData={ctscanRegisternavigationData}
              >
                <FontAwesomeIcon icon={ctscanRegisterfaUsersIcon} />
                {ctscanRegisteraddLabel}
              </NavigationLink>
            </li>
          )}
          {onClick && (
            <li>
              <button className="btn-action-modal" onClick={onClick}>
                <FontAwesomeIcon icon={onClickIcon} size={onClickSize} />
                {buttonLabel}
              </button>
            </li>
          )}
          {onClickCategoryRegister && (
            <li>
              <button
                className="btn-action-modal"
                onClick={onClickCategoryRegister}
              >
                <FontAwesomeIcon
                  icon={onClickCatRegIcon}
                  size={onClickCatRegSize}
                />
                {buttonCatRegLabel}
              </button>
            </li>
          )}
          {onClickSupplierRegister && (
            <li>
              <button
                className="btn-action-modal"
                onClick={onClickSupplierRegister}
              >
                <FontAwesomeIcon
                  icon={onClickSupRegIcon}
                  size={onClickSupRegSize}
                />
                {buttonSupRegLabel}
              </button>
            </li>
          )}
          {itemizedSalesonClick && (
            <li>
              <button
                className="btn-action-modal"
                onClick={itemizedSalesonClick}
              >
                <FontAwesomeIcon
                  icon={itemizedSalesIcon}
                  size={itemizedSalesSize}
                />
                {itemizedSalesLabel}
              </button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default TopActionMenus;
